import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { BADGES } from "./badges.data";
import { Badge } from "./badges.interface";
import { BadgesDialogComponent } from "./badges-dialog/badges-dialog.component";

@Component({
  selector: "app-badges",
  templateUrl: "./badges.component.html",
  styleUrls: ["./badges.component.scss"],
  standalone: false,
})
export class BadgesComponent implements OnInit {
  @Input() badges: Badge[] = BADGES;
  @Input() selected: Badge[] = [];
  @Output() selectedChange = new EventEmitter<Badge[]>();

  useBadgesEnabled = false;

  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.useBadgesEnabled = this.selected.length > 0;
  }

  toggleUseBadges(checked: boolean) {
    this.useBadgesEnabled = checked;
  }

  toggle(b: Badge) {
    const next = this.isSelected(b)
      ? this.selected.filter((x) => x.label !== b.label)
      : [...this.selected, b];
    this.selectedChange.emit(next);
  }

  isSelected(b: Badge) {
    return this.selected.some((x) => x.label === b.label);
  }

  openAddBadgeDialog() {
    const ref = this.dialog.open(BadgesDialogComponent, {
      width: "400px",
      panelClass: "app-dialog-panel",
    });
    ref.afterClosed().subscribe((badge: Badge | undefined) => {
      if (!badge) {
        return;
      }
      this.badges = [...this.badges, badge];
      this.selectedChange.emit([...this.selected, badge]);
    });
  }

  getBadgeTitle(b: Badge): string {
    const key = `badges.${b.label}.title`;
    const t = this.translate.instant(key) as string;
    return t !== key ? t : b.label;
  }

  getBadgeDescription(b: Badge): string {
    if (b.description) {
      return b.description;
    }
    const key = `badges.${b.label}.description`;
    const t = this.translate.instant(key) as string;
    return t !== key ? t : "";
  }
}
